import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FanGroupForm = ({ unit, onChange, onCopy, onDelete }) => {
  const handleChange = (key, value) => {
    onChange({
      ...unit,
      [key]: value,
    });
  };

 const getImageSrc = () => {
  const type = unit.deviceType?.toLowerCase();
  const sub = unit.subType?.toLowerCase();

  if (type === 'cati') {
    if (sub === 'dikey') return '/images/aspirator/cati_dikey.png';
    if (sub === 'yatay') return '/images/aspirator/cati_yatay.png';
    return '/images/aspirator/cati.png';
  }
  if (type === 'kanalli') {
    if (sub === 'yuvarlak') return '/images/aspirator/kanal_yuvarlak.png';
    if (sub === 'dikdortgen') return '/images/aspirator/kanal_dikdortgen.png';
    return '/images/aspirator/kanalli.png';
  }
  if (type === 'aksiyel') return '/images/aspirator/aksiyel.png';
  if (type === 'duman') return '/images/aspirator/duman_tahliye.png';
  if (type === 'exproof') return '/images/aspirator/exproof.png';
  if (type === 'hucreli') return '/images/aspirator/hucreli_aspirator.png'; // ✅ EKLENDİ
  return null;
};


  const fieldStyle = { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 };
  const labelStyle = { width: 100, fontWeight: 'bold' };
 const inputStyle = {
  flex: 1,
  padding: '8px 10px',
  borderRadius: 6,
  border: '1px solid #ccc',
  fontSize: '15px',
  height: 38,
  lineHeight: '1.2',
  boxSizing: 'border-box',
};

  const imageSrc = getImageSrc();

  const renderSubOptions = () => {
    if (unit.deviceType === 'cati') {
      return (
        <motion.div {...motionProps} style={fieldStyle}>
          <label style={labelStyle}></label>
        <select
  value={unit.subType || ''}
  onChange={(e) => handleChange('subType', e.target.value)}
  style={{
    flex: 1,
    padding: '8px 10px',
    borderRadius: 6,
    border: '1px solid #ccc',
    fontSize: '15px',
    height: 38,
    lineHeight: '1.2',
    boxSizing: 'border-box',
  }}
>

            <option value="">Seçiniz</option>
            <option value="dikey">Dikey Atışlı</option>
            <option value="yatay">Yatay Atışlı</option>
          </select>
        </motion.div>
      );
    }

    if (unit.deviceType === 'kanalli') {
      return (
        <motion.div {...motionProps} style={fieldStyle}>
          <label style={labelStyle}></label>
         <select
  value={unit.subType || ''}
  onChange={(e) => handleChange('subType', e.target.value)}
  style={{
    flex: 1,
    padding: '8px 12px',
    borderRadius: 6,
    border: '1px solid #ccc',
    fontSize: '15px',
    height: '36px',
  }}
>

            <option value="">Seçiniz</option>
            <option value="yuvarlak">Yuvarlak Kanal</option>
            <option value="dikdortgen">Dikdörtgen Kanal</option>
          </select>
        </motion.div>
      );
    }

    if (unit.deviceType === 'exproof') {
      return (
        <motion.div {...motionProps} style={fieldStyle}>
          <label style={labelStyle}>Ex-proof Sınıf:</label>
          <input type="text" value={unit.exproofClass || ''} onChange={(e) => handleChange('exproofClass', e.target.value)} placeholder="Örn: IIB T4" style={inputStyle} />
        </motion.div>
      );
    }

    return null;
  };

  const motionProps = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.3 }
  };

  return (
    <motion.div {...motionProps} style={{ border: '1px solid #ccc', borderRadius: 10, padding: 20, backgroundColor: '#fff', boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
      <div style={{ textAlign: 'center', marginBottom: 10, minHeight: 160 }}>
        {imageSrc ? (
          <img src={imageSrc} alt="Fan Görseli" style={{ maxWidth: '100%', height: 120, objectFit: 'contain' }} />
        ) : (
          <p style={{ color: '#888', fontStyle: 'italic' }}>Fan Tipi Seçiniz</p>
        )}
      </div>

      <h3 style={{ textAlign: 'center', marginBottom: 20 }}>
        {unit.unitName} <span style={{ fontWeight: 'normal', fontSize: '0.9rem' }}>x {unit.quantity || 1} adet</span>
      </h3>

     <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
  <label style={{ width: 100, fontWeight: 'bold' }}>Fan Tipi:</label>
 <select
  value={unit.deviceType || ''}
  onChange={(e) => handleChange('deviceType', e.target.value)}
  style={{
    flex: 1,
    padding: '8px 10px',
    borderRadius: 6,
    border: '1px solid #ccc',
    fontSize: '15px',
    height: 38,
    lineHeight: '1.2',
    boxSizing: 'border-box',
  }}
>
  <option value="">Seçiniz</option>
  <option value="cati">Çatı Tipi</option>
  <option value="kanalli">Kanal Tipi</option>
  <option value="aksiyel">Aksiyel</option>
  <option value="duman">Duman Tahliye Fanı</option>
  <option value="exproof">Ex-Proof</option>
  <option value="hucreli">Hücreli Aspiratör</option> {/* ✅ Bu satırı ekle */}
</select>

</div>


      <AnimatePresence>{renderSubOptions()}</AnimatePresence>

      <div style={fieldStyle}>
        <label style={labelStyle}>Debi (m³/h):</label>
        <input type="number" value={unit.aspFlow || ''} onChange={(e) => handleChange('aspFlow', e.target.value)} placeholder="Örn: 2000" style={inputStyle} />
      </div>

      <div style={fieldStyle}>
        <label style={labelStyle}>Basınç (Pa):</label>
        <input type="number" value={unit.aspPressure || ''} onChange={(e) => handleChange('aspPressure', e.target.value)} placeholder="Örn: 250" style={inputStyle} />
      </div>

      <div style={fieldStyle}>
        <label style={labelStyle}>Adet:</label>
        <input type="number" min="1" value={unit.quantity || ''} onChange={(e) => handleChange('quantity', e.target.value)} placeholder="Örn: 2" style={inputStyle} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}>
        <button onClick={onCopy} style={{ backgroundColor: '#f0ad4e', color: 'white', padding: '6px 12px', borderRadius: 6 }}>Kopyala</button>
        <button onClick={onDelete} style={{ backgroundColor: '#d9534f', color: 'white', padding: '6px 12px', borderRadius: 6 }}>Sil</button>
      </div>
    </motion.div>
  );
};

export default FanGroupForm;
